/**
 * 产品线管理api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();

export function getProductLineList(params) {
	/**
	 * 获取产品线列表
	 * @param {Object} params
	 */
	return api.get('/api/production_line', params)
}

export function deleteProductLinefo(id) {
	/**
	 * 删除产品线通过id
	 * @param {String} id
	 */
	return api.delete(`/api/production_line/${id}`)
}

export function getProductLineDetail(id) {
	/**
     * 获取产品线详情通过id
     * @param {String} id
     */
	return api.get(`/api/production_line/${id}`)
}

export function putProductLine(id, params) {
	/**
     * 修改产品线通过id
     * @param {String} id
     * @param {Object} params
     */
	return api.put(`/api/production_line/${id}`, params)
}

export function postProductLine(params) {
	/**
     * 新增产品线
     * @param {Object} params
     */
	return api.post(`/api/production_line`, params)
}
export function gethscodeByTemplate(params) {
	/***
	 * 获取模板的目标市场
	 * @param {object} params
	 */
	return api.get(`/api/database_template_menu_v3/destination_market`, params)
}